// extracted by mini-css-extract-plugin
export default {"title":"title_title__CL1FB","decorArrowWrapper":"title_decorArrowWrapper__OtfgU","number":"title_number__hzyGg","text":"title_text__5wGCH"};